import * as Constants from '../constants/media';

const initialState = {
  activeMediaId: '',
  activeMedia: [],
  petMedia: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.GET_PET_MEDIA_SUCCESS:
      return {
        ...state,
        petMedia: action.payload,
      };
    case Constants.GET_MEDIA_INFO_SUCCESS:
      return {
        ...state,
        activeMedia: [].concat(action.payload),
      };
    case Constants.SET_ACTIVE_MEDIA:
      return {
        ...state,
        activeMediaId:
          typeof action.payload === 'number' || action.payload === null
            ? action.payload
            : state.activeMediaId,
        activeMedia: typeof action.payload === 'object' ? action.payload : state.activeMedia,
      };
    case Constants.DELETE_PET_MEDIA_SUCCESS:
      return {
        ...state,
        petMedia: [],
      };
    default:
      return state;
  }
};
